module.exports = require("admin/components/color-input");